import { Activity, AlertTriangle, Repeat, Timer } from "lucide-react";
import type { BlogExercise } from "@/lib/blog-types";

const DIFFICULTY_STYLES: Record<BlogExercise["difficulty"], string> = {
  Beginner: "bg-primary/10 text-primary",
  Intermediate: "bg-accent text-primary",
  Advanced: "bg-secondary text-primary",
};

export function ExerciseCard({ exercise, index }: { exercise: BlogExercise; index: number }) {
  const e = exercise;
  return (
    <article className="rounded-2xl border border-border bg-card p-5 shadow-sm">
      <div className="flex items-start justify-between gap-3">
        <h3 className="font-display text-lg font-bold text-primary">
          {index}. {e.name}
        </h3>
        <span className={`shrink-0 rounded-full px-3 py-1 text-[11px] font-semibold ${DIFFICULTY_STYLES[e.difficulty]}`}>
          {e.difficulty}
        </span>
      </div>

      <p className="mt-3 text-sm text-foreground/75">
        <span className="font-semibold text-primary">Starting position: </span>
        {e.startingPosition}
      </p>

      <ol className="mt-3 space-y-2 text-sm text-foreground/80">
        {e.steps.map((s, i) => (
          <li key={s} className="flex gap-2">
            <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary/10 text-[11px] font-bold text-primary">
              {i + 1}
            </span>
            <span>{s}</span>
          </li>
        ))}
      </ol>

      <div className="mt-4 flex flex-wrap gap-2 text-xs text-primary">
        {e.sets && (
          <span className="inline-flex items-center gap-1 rounded-full border border-border px-3 py-1">
            <Activity className="h-3 w-3" /> {e.sets}
          </span>
        )}
        {e.reps && (
          <span className="inline-flex items-center gap-1 rounded-full border border-border px-3 py-1">
            <Repeat className="h-3 w-3" /> {e.reps}
          </span>
        )}
        {e.duration && (
          <span className="inline-flex items-center gap-1 rounded-full border border-border px-3 py-1">
            <Timer className="h-3 w-3" /> {e.duration}
          </span>
        )}
      </div>

      {e.suitableFor && <p className="mt-3 text-xs text-muted-foreground">Suitable for: {e.suitableFor}</p>}
      {e.safety && (
        <p className="mt-3 flex gap-2 rounded-xl bg-secondary/40 p-3 text-xs text-foreground/75">
          <AlertTriangle className="h-4 w-4 shrink-0 text-primary/70" />
          <span>{e.safety}</span>
        </p>
      )}
    </article>
  );
}
